import axios from 'axios';

export default {
    post: async function(endpoint, obj) {
        // Add analytics call
        // const data = JSON.stringify(obj); remove stringify see if data would post
        return axios({
            method: 'post',
            url: endpoint,
            responseType: 'json',
            data: obj
        }).catch(error => {
            // eslint-disable-next-line
            console.log('Trigger Page Goals error: ' + error);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/resources/trigger-page-goals.js